import captureClose from "assets/icons/captureClose.svg";
const ImageViewPopup = ({ imageSrc, onClose, zoomLevel, setZoomLevel, onError = () => {} }) => {
    const handleZoomIn = () => setZoomLevel(prev => Math.min(prev + 0.2, 3));
    const handleZoomOut = () => setZoomLevel(prev => Math.max(prev - 0.2, 0.5));

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div className="rounded-lg max-w-3xl w-full h-[100vh] flex items-center">
                <div className="absolute flex justify-between mb-2 z-50 p-4 w-full top-[10px]">
                    <div>
                        <button
                            onClick={handleZoomOut}
                            className="bg-blue-500 text-white px-4 py-2 rounded  w-[42px] h-[42px] mr-3"
                        >-</button>
                        <button
                            onClick={handleZoomIn}
                            className="bg-blue-500 text-white px-4 py-2 rounded w-[42px] h-[42px]"
                        >+</button>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-red-500 font-bold text-xl hover:text-red-700"
                    >
                        <img src={captureClose} alt="" className="htCaptureClose"/>
                    </button>
                </div>
                <div className="overflow-auto max-h-[80vh] w-full">
                    <img
                        src={imageSrc}
                        alt="Full size"
                        className="w-full h-auto"
                        style={{ transform: `scale(${zoomLevel})`, transition: 'transform 0.2s' }}
                        onError={onError}
                    />
                </div>
            </div>
        </div>
    );
};
export default ImageViewPopup;
